import type { FAQ } from 'src/components/FaqAccordion/FaqAccordion';

export const faqs: FAQ[] = [
  {
    question: 'Who should advertise on SEEK Business?',
    answer:
      'Anybody who owns a business and would like to sell a business online by liaising directly with buyers.',
  },
  {
    question: 'How long will it take me to sell my business?',
    answer:
      'On average, it takes 6–9 months to sell, sometimes more, especially if your business is valued at $1 million or more.',
  },
  {
    question: 'Do you charge commission?',
    answer: 'No, we do not charge commission and there are no hidden fees.',
  },
  {
    question: 'How can I access resources before listing my business?',
    answer:
      "Register with SEEK Business to access our helpful resources, such as our value calculator guide. Then purchase an ad pack if and when you're ready to sell a business.",
  },
  {
    question: 'What is a buyer enquiry?',
    answer:
      "Buyers can contact you directly via the contact details listed in your ad; this is a buyer enquiry. Buyer enquiries are included as part of the upfront fee for all advertising options, except the 'Pay Per Enquiry’ option. With the 'Pay Per Enquiry’ option, the upfront fees are waived. Instead you are billed for each individual buyer enquiry received.",
  },
  {
    question: 'What are Boosted ads?',
    answer:
      'Boosted ads are given priority position in search results and buyer emails. Boosted ads are cycled through one of two "Featured" slots at the top of relevant search results and at the top of our recommended business buyer emails to give your ads more prominence, reach a broader audience and receive enquiries more quickly compared to standard ad listings.',
  },
  {
    question: 'How can I boost my ads?',
    answer:
      'Boosted ads are available for purchase as an add-on with the 6 month ad pack and List Until Sold advertising options when you checkout online. For the Pay per enquiry option, Boosted ads are automatically included for free until you reach your capped number of enquiries. Contact us on 13 73 35 to find out more.',
  },
  {
    question: 'Why should I choose the Pay Per Enquiry option?',
    answer:
      "The 'Pay Per Enquiry’ option means you only pay for any eligible buyer enquires that you receive - nothing more, nothing less. This means the upfront fees are waived. Instead, you are invoiced only for the enquiries you receive, once a month up to the listed cap amount. Included in this option are free add-on boost products to give your ad maximise exposure on our website until you reach your cap. These products are normally sold separately. The definition of an eligible buyer for the purposes of this option is a buyer enquiry that has either a valid phone number and/or a valid email address.",
  },
  {
    question:
      'If I choose the Pay Per Enquiry option, how much can I expect to pay?',
    answer:
      'If you receive eligible buyer enquiries, you will be invoiced monthly for the enquiries you received that month, until you reach the listed cap. Once you’ve reached your cap, further enquiries will be free, and your business will continue to be advertised until sold.',
  },
  {
    question: 'If I choose the Pay Per Enquiry option, can I change my mind?',
    answer:
      'You can choose to cancel your Pay Per Enquiry advertisement at any time and for any reason.',
  },
  {
    question: 'Will my ad be placed on other websites?',
    answer:
      'No, when you advertise with SEEK Business your ad is only displayed on our website.',
  },
];

export const faqsFreemium: FAQ[] = [
  {
    question: 'Who should advertise on SEEK Business?',
    answer:
      'Anybody who owns a business and would like to sell a business online by liaising directly with buyers.',
  },
  {
    question: 'How long will it take me to sell my business?',
    answer:
      'On average, it takes 6–9 months to sell, sometimes more, especially if your business is valued at $1 million or more.',
  },
  {
    question: 'Do you charge commission?',
    answer: 'No, we do not charge commission and there are no hidden fees.',
  },
  {
    question: 'How can I access resources before listing my business?',
    answer:
      "Register with SEEK Business to access our helpful resources, such as our value calculator guide. Then purchase an ad pack if and when you're ready to sell a business.",
  },
  {
    question: 'What are the daily buyer recommendation emails?',
    answer:
      "Each day, we send personalised emails to registered buyers featuring businesses that match their specific interests. These recommendations help your business catch buyers' attention even when they're not actively browsing the SEEK Business website.",
  },
  {
    question: 'What are featured ads?',
    answer:
      "Featured ads are given priority position in search results and buyer emails. These are cycled through one of two 'Featured' slots at the top of relevant search results and at the top of our recommended business buyer emails. Featured ads give your business more prominence, reach a broader audience and receive enquiries more quickly compared to standard ad listings.",
  },
  {
    question: 'Will my ad be placed on other websites?',
    answer:
      'No, when you advertise with SEEK Business your ad is only displayed on our website.',
  },
];
